<template lang="pug">
  div(:class="'content-slider '+'container-'+this._uid")
    div(class="slider-nav")
      .slider-nav-item(v-for="(d, i) in this.sliders[0].slides")
        a.directLink(v-if="!d.type" :href="d.url" class="item" :key="'slider-nav-item-' + i")
          h4.title
            vue-markdown(:source='d.title')
          vue-markdown(:source='d.desc' class="desc")
        router-link(v-if="d.type" class="item" :to="{ path: d.slug ? '/' + d.slug : d.url, params: {}}" :key="'slider-nav-item-' + i")
          h4.title
            vue-markdown(:source='d.title')
          vue-markdown(:source='d.desc' class="desc")
      router-link.slider-link.button.special.item(:to="{ path: this.sliders[0].link || null, params:{}}" v-show="this.sliders[0].link")
        h4.title {{ "Browse all Masterclasses" }}
          //- vue-markdown(:source='this.sliders[0].link')
</template>

<script>
import Vue from 'vue'
import sectionBase from '@/components/sections/sectionBase.js'
import anime from 'animejs'

// Storing animation target elements
const animTargets = {
  container: '#container'
}

// component instance
var contentSlider = Vue.component('content-slider', {
  name: 'contentSlider',
  mixins: [sectionBase],
  props: [],
  data: function () {
    return {
    }
  },
  watch: {
  },
  methods: {
    // TODO: create a timed loop to put an active class on the items
  },
  computed: {
    sliders () {
      let slideData = this.payload.fields.content
      let sliders = []

      // TODO: will parse all but only first one is used ATM
      slideData.forEach((d, i) => {
        let slider = {name: d.fields.title, link: d.fields.link, slides: []}

        if (d.fields.itemReferences.length > 0) {
          d.fields.itemReferences.forEach((s, n) => {
            // let b = s.fields.description && s.fields.description.substr(0, 40)
            // b = b && b.substr(0, Math.min(b.length, b.lastIndexOf(' ')))
            let b = s.fields.description

            Vue.set(slider.slides, n, {title: s.fields.title, desc: s.fields.description && `${b}`, type: s.fields.type, url: `${s.fields.type ? '/' + s.fields.type.toLowerCase() + '/' + s.sys.id : s.fields.directRef}`})
          })
          Vue.set(sliders, i, slider)
        } else {
          d.fields.itemTitles.forEach((s, n) => {
            Vue.set(slider.slides, n, {title: s, desc: d.fields.itemDescriptions[n]})
          })
          Vue.set(sliders, i, slider)
        }
      })

      return sliders
    },
    actions () {
      // let component = this

      return {
        SET: () => {
          return anime({
            targets: animTargets.container + this._uid,
            easing: 'easeInOutQuad',
            opacity: [
              { value: '1' }
            ],
            translateX: [
              { value: 0 }
            ],
            translateY: [
              { value: 0 }
            ],
            borderColor: [
              { value: '#F0F0F0' }
            ],
            boxShadow: [
              { value: '0px 0px 10px rgba(211,211,211,1)' }
            ],
            duration: 200,
            begin: function (e) {
              console.log('set')
            },
            complete: function () {
            }
          })
        }
      }
    }
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default contentSlider
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sections/contentSlider.vue